export default __webpack_public_path__ + "static/cloud-1-55cf91f69e4451c53f51f6ecbc5c787d.png";